import React, { useEffect, useState } from 'react';
import PageHeader from 'src/Components/Customer/PageHeader';
import BackIcon from "src/assets/images/back-icon.png";
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import SearchFilterInput from 'src/Components/GlobalComponents/SearchFilterInput';
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';
import SelectDropdown from 'src/Components/GlobalComponents/SelectDropdown';
import IsFavoriteComponent from 'src/Components/Customer/ProductsAndServicesComponents/IsFavoriteComponent';
import { IDiseaseItem, IDropDownArray, ISpecializationItem } from 'src/types/GlobalInterfaces';
import httpRequest from 'src/helpers/httpRequest';
import { toast } from 'react-toastify';
import { IPaginated } from 'src/types/paginated';
import { cityList } from 'src/Config/CityList';
import qs from "qs";
import { CircularProgress } from '@mui/material';
import { convertMonthsToReadableFormat, getInitialsImage } from 'src/helpers/helperFunctions';
import PaginationComponet from 'src/Components/GlobalComponents/PaginationComponet';
import BookAppointmentBtn from 'src/Components/BookAppointmentBtn';
import wishlistIcon from 'src/assets/images/no-appointments-icon.png'
import { availabilityList, CURRENCY } from 'src/lib/constans';
interface IObj {
    _id: string;
    userId: string; // doctor id....
    customersDetails: {
        firstName: string;
        lastName: string;
        coverPhoto: null | string;
        [key:string]:any;
    };
    providersDetails: {
        education: { course: string }[];
        workExperience: string;
    };
    specializationDetails: { name: string }[];
    isLiked: boolean;
    city: string;
    startingPrice: number;
    createdAt: string;
    allReviews: { reviews: [] }[];
    averageStar: number[];
    [key: string]: any;
};
interface IFILTERSTATES {
    specialId: string;
    diseasesId: string[];
    name: string;
    days: string[];
    city: string;
    appointmentType: "" | "online" | "physical";
};
interface IQUERYPARAMS {
    page: number;
    limit: number;
    specialId: string;
    diseasesId: string[];
    name: string;
    days: string[];
    city: string;
    appointmentType: "" | "online" | "physical";
};

const FindDoctors: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const searchQuery = params.get("searchQuery")
    const appointmentTypeOptions: IDropDownArray[] = [
        { value: 'online', label: 'Online Appointment' },
        { value: 'physical', label: 'In-Clinic Appointment' }
    ];


    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [allDoctors, setAllDoctors] = useState<IObj[]>([]);
    const [filterStates, setFilterStates] = useState<IFILTERSTATES>({
        specialId: "",
        diseasesId: [],
        name: searchQuery || "",
        days: [],
        city: "",
        appointmentType: "",
    });
    const [queryParams, setQueryParams] = useState<IQUERYPARAMS>({
        page: 1,
        limit: 9,
        specialId: "",
        name: searchQuery || "",
        city: "",
        diseasesId: [],
        days: [],
        appointmentType: "",
    });
    const [paginated, setPaginated] = useState<IPaginated>({
        currentPage: 1,
        totalPages: 1,
    });

    const handleSubmit = () => {
        const { specialId, diseasesId, name, days, city, appointmentType } = filterStates;
        setQueryParams(prev => ({ ...prev, page: 1, specialId, diseasesId, name, days, city, appointmentType }));
    };

    const [specializationStates, setSpecializationStates] = useState<{ loader: boolean; allSpecializations: IDropDownArray[] }>({
        loader: false,
        allSpecializations: [],
    });
    const fetchAllServices = async () => {
        setSpecializationStates(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<ISpecializationItem[]>({ path: `/provider/special/get` });
        if (res) {
            setSpecializationStates(prev => ({ ...prev, allSpecializations: res?.map(v => ({ label: v?.name, value: v?._id })) }));
        } else {
            toast(err, { type: 'error' });
        }
        setSpecializationStates(prev => ({ ...prev, loader: false }));
    };

    const [diseasStates, setDiseasStates] = useState<{ loader: boolean; allDisease: IDropDownArray[] }>({
        loader: false,
        allDisease: [],
    });
    const fetchAllDisease = async () => {
        setDiseasStates(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<IDiseaseItem[]>({ path: `/provider/diseases/get` });
        if (res) {
            setDiseasStates(prev => ({ ...prev, allDisease: res?.map(v => ({ label: v?.name, value: v?._id })) }));
        } else {
            toast(err, { type: 'error' });
        }
        setDiseasStates(prev => ({ ...prev, loader: false }));
    };

    const fetchDoctors = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<{ documents: IObj[]; paginated: IPaginated }>({ path: `/provider/all/doctor?${qs.stringify(queryParams)}` });
        if (res) {
            const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } = res;
            setAllDoctors(documents);
            setPaginated(paginated);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };

    useEffect(() => {
        fetchDoctors();
    }, [queryParams]);

    // useEffect(() => {
    //     if (searchQuery) {
    //         setQueryParams((prev: any) => ({
    //             ...prev,
    //             name: searchQuery
    //         }))
    //         setFilterStates(prev => ({ ...prev, name: searchQuery }))
    //     }

    // }, [searchQuery])


    useEffect(() => {
        fetchAllServices();
        fetchAllDisease();
    }, []);

    const BackButton: React.FC = () => {
        return (
            <button className="right-bar-icon" onClick={() => navigate(-1)}>
                <img src={BackIcon} alt="back-icon" />
            </button>
        );
    };
    return (
        <div className="container-1480 h-3vw">
            <PageHeader title="Find Doctor" isButton={true} ButtonComponent={BackButton} />
            <div style={{ padding: 0 }} className="parent-box">
                <div className="new-find-doctor-search-main">
                    <div className="new-find-doctor-search">
                        <SearchFilterInput
                            key={queryParams?.name}
                            searchVal={filterStates?.name}
                            onChangeText={(val: string) => setFilterStates(prev => ({ ...prev, name: val }))}
                            placeHolder="Doctor"
                            containerExtraStyle={{
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                            debounceTime={0}
                            inputExtraStyle={{
                                width: '100%',
                                borderRadius: "50rem",
                                padding: "0.5rem 1rem",
                                border: '1px solid #004540',
                                margin: 0,
                                boxShadow: '2px 2px 10px rgba(0, 0, 0, .16)',
                            }}
                        />
                        <PrimaryBtn onPress={handleSubmit} type="button" ButtonText="Search" btnExtraStyle={{ borderRadius: '100px', padding: 0, background: "#00443F" }} />
                    </div>
                    <div className="new-find-doctor-filters">
                        <SelectDropdown
                            checkboxShow={false}
                            isMulti={false}
                            options={cityList}
                            data={cityList?.filter(v => v?.value === filterStates?.city)}
                            setData={(newVal) => setFilterStates(prev => ({ ...prev, city: newVal[0]?.value || "" }))}
                            extraClass="doctors-list-dropdown doctors-list-dropdown-location"
                            placeholder={{ selectSomeItems: "Location" }}
                        />
                        <SelectDropdown
                            checkboxShow={true}
                            isMulti={true}
                            options={availabilityList}
                            data={availabilityList?.filter(v => filterStates?.days.includes(v?.value))}
                            setData={(newVal) => setFilterStates(prev => ({ ...prev, days: newVal?.map(v => v.value) }))}
                            extraClass="doctors-list-dropdown doctors-list-dropdown-availability"
                            placeholder={{ selectSomeItems: "Availability" }}
                        />
                        <SelectDropdown
                            checkboxShow={false}
                            isMulti={false}
                            loader={specializationStates?.loader}
                            options={specializationStates?.allSpecializations}
                            data={specializationStates?.allSpecializations?.filter(v => v.value === filterStates?.specialId)}
                            setData={(newVal) => setFilterStates(prev => ({ ...prev, specialId: newVal[0]?.value || "" }))}
                            extraClass="doctors-list-dropdown doctors-list-dropdown-Specializations"
                            placeholder={{ selectSomeItems: "Specializations" }}
                        />
                        <SelectDropdown
                            checkboxShow={true}
                            isMulti={true}
                            loader={diseasStates?.loader}
                            options={diseasStates?.allDisease}
                            data={diseasStates?.allDisease?.filter(v => filterStates?.diseasesId.includes(v?.value))}
                            setData={(newVal) => setFilterStates(prev => ({ ...prev, diseasesId: newVal?.map(v => v.value) }))}
                            extraClass="doctors-list-dropdown doctors-list-dropdown-Disease"
                            placeholder={{ selectSomeItems: "Disease" }}
                        />
                        <SelectDropdown
                            checkboxShow={false}
                            isMulti={false}
                            options={appointmentTypeOptions}
                            data={appointmentTypeOptions?.filter(v => v.value === filterStates?.appointmentType)}
                            setData={(newVal) => setFilterStates(prev => ({ ...prev, appointmentType: newVal[0]?.value || "" }))}
                            extraClass="doctors-list-dropdown doctors-list-dropdown-Appointment"
                            placeholder={{ selectSomeItems: "Appointment type" }}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 find-docter-card-main-grid md:grid-cols-2 lg:grid-cols-3 gap-2">
                    {isLoader ?
                        <div className="col-span-3 text-center">
                            <CircularProgress size={20} style={{ color: "#004540" }} />
                        </div>
                        : allDoctors?.length ?
                            allDoctors.map((item: IObj) => (
                                <div key={item?.userId} className="border-[#00443f] border rounded-lg find-docter-card-main">
                                    <div className="flex flex-col gap-3">
                                        <div className="flex gap-2 relative">
                                            <div className="Prescription-requird-main flex justify-between">
                                                <div></div>
                                                <IsFavoriteComponent
                                                    productId={item?.userId}
                                                    isFav={item?.isLiked || false}
                                                    category="doctor"
                                                    onSuccess={(obj: { productId: string, isLiked: boolean; }) =>
                                                        setAllDoctors(prev => prev?.map(v => v?.userId === obj?.productId ? { ...v, isLiked: obj?.isLiked } : v))
                                                    }
                                                />
                                            </div>
                                            <div className="max-w-[5vw] rounded-lg h-fit overflow-hidden">
                                                <img
                                                    src={`${item?.customersDetails?.coverPhoto || ""}`}
                                                    onError={(e) => {
                                                        const target = e.target as HTMLImageElement;
                                                        target.src = getInitialsImage(`${item?.customersDetails?.firstName || ""} ${item?.customersDetails?.lastName || ""}`, 112, 48, "#00443f");
                                                    }}
                                                    alt={`${item?.customersDetails?.firstName || ""} ${item?.customersDetails?.lastName || ""}`}
                                                    className="aspect__square"
                                                />
                                            </div>
                                            <div className="w-full height-issue-resolve-find-doctor flex flex-col gap-1 ">
                                                <h3 className="font-size-18px font-Poppins-SemiBold theme-color-green capitalize flex flex-row gap-1 items-center">{`${item?.customersDetails?.firstName || ""} ${item?.customersDetails?.lastName || ""}`}

                                                    {item?.customersDetails?.userVerified === "verified" &&
                                                        <span><FontAwesomeIcon icon={faCircleCheck} className="text-[#00443f]" /></span>
                                                    }
                                                </h3>
                                                <h6 className="font-size-16px flex flex-wrap text-[#202020] font-Poppins-Medium">
                                                    {item?.specializationDetails &&
                                                        <span>
                                                            {item?.specializationDetails?.slice(0, 4)?.map(v => v?.name?.length > 15 ? `${v?.name?.slice(0, 15)}...` : v?.name)?.join(" | ")}
                                                        </span>
                                                    }
                                                </h6>
                                                <p className="font-size-16px flex flex-wrap text-[#393939] font-Poppins-Regular">
                                                    {item?.providersDetails?.education &&
                                                        <span>
                                                            {item?.providersDetails?.education?.slice(0, 2)?.map(v => v?.course?.length > 15 ? `${v?.course?.slice(0, 15)}...` : v?.course)?.join(", ")}
                                                        </span>
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                        <div className="find-doctor-car-experience">
                                            <div className="flex flex-col">
                                                <span className="font-size-15px text-[#707070] font-Poppins-Regular">Experience</span>
                                                <span className="font-size-15px text-[#202020] font-Poppins-Medium">{convertMonthsToReadableFormat(Number(item?.providersDetails?.workExperience) || 0)}</span>
                                            </div>
                                            <p style={{ border: '0.2px solid rgb(131 126 126 / 21%)' }}></p>
                                            <div className="flex flex-col gap-1">
                                                <span className="font-size-15px text-[#707070] font-Poppins-Regular">Reviews</span>
                                                <span className="font-size-15px text-[#202020] font-Poppins-Medium">{item?.allReviews?.[0]?.reviews?.length || 0}</span>
                                            </div>
                                            <p style={{ border: '0.2px solid rgb(131 126 126 / 21%)' }}></p>
                                            <div className="flex flex-col gap-1">
                                                <span className="font-size-15px text-[#707070] font-Poppins-Regular">Rating</span>
                                                <div className="flex gap-1">
                                                    {[1, 2, 3, 4, 5].map((v) => (
                                                        <FontAwesomeIcon
                                                            key={v}
                                                            className={`font-size-16px ${(item?.averageStar?.[0] || 0) >= v ? 'text-[#FF9B29]' : 'text-[#707070]'}`}
                                                            icon={faStar}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p className="font-size-16px text-[#202020] font-Poppins-Medium">
                                                Starting from: <span className="font-size-18px font-Poppins-SemiBold theme-color-green">{CURRENCY} {item?.startingPrice || "-"}</span>
                                            </p>
                                        </div>
                                        <div className="find-doctor-card-btns">
                                            <PrimaryBtn
                                                type="button"
                                                ButtonText="View Profile"
                                                btnExtraStyle={{ borderRadius: '100px', background: "#FFFF", color: '#00443F', border: '1px solid #00443F' }}
                                                onPress={() => navigate(`/doctor-public-profile/${item?.userId}/view`)}
                                            />
                                            <BookAppointmentBtn
                                                doctorId={item?.userId}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                            :
                            <div className="col-span-3 text-center flex flex-col justify-center items-center">
                                {/* <div className='parchi-icon-order'> */}
                                <img src={wishlistIcon} alt="" />

                                <p className="text-center font-Poppins-Medium font-size-22px">No doctors available matching your search.</p>
                            </div>
                    }
                </div>
                <PaginationComponet
                    currentPage={paginated.currentPage || 1}
                    total={paginated.totalPages || 1}
                    setCurrentPage={(_page) => setQueryParams(prev => ({ ...prev, page: _page }))}
                />
            </div>
        </div>
    );
};

export default FindDoctors;